import { useEffect, useState } from 'react'
import { BILL_STATUSES } from 'utils/constants'

interface RefetchBatchBillProps {
  refetchFunction: () => void
  isCreatingBatchBill: boolean
  isUpdatingBatchBill: boolean
  isPayingBatchBill: boolean
  batchBillStatus: string
  afterSaveCallback: (() => void) | null
}

export const useRefetchBatchBill = ({
  refetchFunction,
  isCreatingBatchBill,
  isUpdatingBatchBill,
  isPayingBatchBill,
  batchBillStatus,
  afterSaveCallback,
}: RefetchBatchBillProps) => {
  const [pageIsSavingOrPaying, setPageIsSavingOrPaying] = useState(false)

  useEffect(() => {
    if (isCreatingBatchBill || isUpdatingBatchBill || isPayingBatchBill) {
      setPageIsSavingOrPaying(true)
    }
  }, [isCreatingBatchBill, isUpdatingBatchBill, isPayingBatchBill])

  useEffect(() => {
    let intervalId

    if (batchBillStatus === BILL_STATUSES.SAVING.id) {
      intervalId = setInterval(() => {
        refetchFunction()
      }, 5000)
      setPageIsSavingOrPaying(true)
    } else {
      clearInterval(intervalId)
      setPageIsSavingOrPaying(false)
      if (afterSaveCallback) {
        afterSaveCallback()
      }
    }
    return () => {
      clearInterval(intervalId)
    }
  }, [batchBillStatus])

  return {
    pageIsSavingOrPaying,
    setPageIsSavingOrPaying,
  }
}
